import { axiosInstance } from "@/axios/interceptors";
import { Member, MemberFileParam } from "@/common/types";
// import {  isEmpty } from "@/common/util";
export default {
  signUp: async (data: any) => {
    return await axiosInstance.post("user", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  userDetail: async (seq: number) => {
    return await axiosInstance.get(`user/${seq}`);
  },

  mypage: async () => {
    return await axiosInstance.get(`user/mypage`);
  },
  updateUser: async (data: Partial<Member>) => {
    return await axiosInstance.patch(`user`, data);
  },
  sealCheck: async (pwd: string) => {
    return await axiosInstance.post(`user/seal-check`,{인감비밀번호:pwd});
  },
  sealFile(seq: number, 도장구분: string, 인감비밀번호: string) {
    return axiosInstance.post(`user/seal-attach-files/${도장구분}`, { 인감비밀번호: 인감비밀번호 }, { responseType: 'blob' })
  },
  priviewFile(seq: number) {
    return axiosInstance.get(`user/download-attach-files/${seq}`, { responseType: 'blob' })
  },
  uploadUserFile(data: MemberFileParam, file: File) {
    const formData = new FormData();
    formData.append('fileinfo', new Blob([JSON.stringify(data)], { type: 'application/json' }));
    formData.append(`multiparts`, file);
    return axiosInstance.post(`user/attach-files`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
  },
  downloadUserFile(저장순번:number, 파일명:string) {
      return axiosInstance.get(`user/download-attach-files/${저장순번}`, {responseType: 'blob'}).then((response) => {
          const blobUrl = window.URL.createObjectURL(response.data);
          const downloadLink = document.createElement('a');
          downloadLink.href = blobUrl;
          downloadLink.setAttribute('download', 파일명);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(blobUrl);
      })
  }
  // signUp(data: any, multifile: File[]) {
  //   const formData = new FormData();
  //   const dtoPart: any = {};
  //   dtoPart["공지순번"] = null;
  //   Object.keys(data).forEach((key: string) => {
  //     if (isEmpty(data[key])) return;
  //     dtoPart[key] = data[key];
  //   });
  //   formData.append("notice", new Blob([JSON.stringify(dtoPart)], { type: "application/json" }));
  //   for (let i = 0; i < multifile.length; i++) {
  //     if (!(multifile[i] instanceof File)) continue;
  //     formData.append(`multiparts`, multifile[i]);
  //   }
  //   return axiosInstance.post("user", formData, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // },
};
